export default __webpack_public_path__ + "static/media/protectedFileIcon.71f5621c.svg";